import { $$ } from '@zimpa/dom';

const CONTAINER_SELECTOR = '.js-fancy-select';
const ITEM_SELECTOR = 'option';

class FancySelect {
    private btn: HTMLElement;
    private dropdown: HTMLElement;
    private documentClick;
    private fancyContainer;
    private selectedIndex: number;
    private options: Array<HTMLElement>;

    public constructor(container: HTMLSelectElement) {
        this.fancyContainer = document.createElement('div');
        this.btn = document.createElement('button');
        this.dropdown = document.createElement('ul');
        this.options = [];

        container.classList.add('c-fancy-select');

        this.fancyContainer.classList.add(
            'c-fancy-select__container',
            'collapsed',
        );

        this.btn.classList.add('c-fancy-select__btn');
        this.dropdown.classList.add('c-fancy-select__dropdown');

        this.selectedIndex = container.selectedIndex;

        this.btn.innerText = container.options[this.selectedIndex].text;
        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            //e.stopPropagation();
            this.openDropdown();
        });

        container.options[this.selectedIndex].classList.add('selected');

        $$(ITEM_SELECTOR, container).forEach(
            (item: HTMLElement, index: number): void => {
                const option: HTMLLIElement = document.createElement('li');
                option.appendChild(document.createTextNode(item.innerText));
                option.className = item.classList.toString();

                option.addEventListener('click', () => {
                    this.options[this.selectedIndex].classList.remove(
                        'selected',
                    );
                    this.selectedIndex = container.selectedIndex = index;
                    option.classList.add('selected');
                    this.btn.innerText = option.innerText;
                    this.closeDropDown();
                });

                this.dropdown.appendChild(option);

                this.options.push(option);
            },
        );

        this.fancyContainer.appendChild(this.btn);
        this.fancyContainer.appendChild(this.dropdown);
        this.insertAfter(container, this.fancyContainer);

        this.documentClick = (docEvent: MouseEvent) => {
            const target = <HTMLElement>docEvent.target;
            if (target === null) {
                return;
            }
            if (target != this.btn) {
                this.closeDropDown();
            }
        };
    }

    private closeDropDown() {
        this.fancyContainer.classList.add('collapsed');
        document.body.removeEventListener('click', this.documentClick);
    }

    private openDropdown() {
        this.fancyContainer.classList.remove('collapsed');
        document.body.addEventListener('click', this.documentClick);
    }

    private insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(
            newNode,
            referenceNode.nextSibling,
        );
    }
}

export function fancySelect(): void {
    $$(CONTAINER_SELECTOR).map(
        (element: HTMLSelectElement): FancySelect => {
            return new FancySelect(element);
        },
    );
}
